import { render, staticRenderFns } from "./Contact.html?vue&type=template&id=7a71c80d&scoped=true&"
import script from "./Contact.js?vue&type=script&lang=js&"
export * from "./Contact.js?vue&type=script&lang=js&"
import style0 from "./Contact.scss?vue&type=style&index=0&id=7a71c80d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a71c80d",
  null
  
)

export default component.exports